import React, {useState, useEffect} from 'react';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import MessageSysadminReaded from '../components/MessageSysadminReaded.js';
import MessageSysadminNew from '../components/MessageSysadminNew.js';
import MessageSysadminEdit from '../components/MessageSysadminEdit.js';

export default function MessageSysadmin({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [searchValue, setSearchValue] = useState('');
	const [offset, setOffset] = useState(0);
	const [loadedCnt, setLoadedCnt] = useState(0);
	const [showReaded, setShowReaded] = useState(false);
	const [messageId, setMessageId] = useState(0);
	const [showNew, setShowNew] = useState(false);
	const [showEdit, setShowEdit] = useState(false);
	const [dataDetail, setDataDetail] = useState({});

	useEffect(() => {
		getData('', offset);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const loadNext = () => {
		setOffset((prevOffset) => {
			let newOffset = prevOffset + usrInfo.LIST_ROWS;
			getData(searchValue, prevOffset + usrInfo.LIST_ROWS);
			return newOffset;
		});
	};

	const onChangeSearch = (value) => {
		setSearchValue(value);
		setOffset(0);
		getData(value, 0);
	};

	const getData = (search, offset) => {
		setLoading(true);

		post('getListMessages', {search: search, offset: offset})
			.then((res) => {
				if (offset === 0) {
					setData(res.data);
				} else {
					setData((prevRows) => {
						const updatedRows = [...prevRows, ...res.data];
						return updatedRows;
					});
				}

				setLoadedCnt(res.data.length);

				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleNew = () => {
		setShowNew(true);
	};

	const closeNew = () => {
		setShowNew(false);
	};

	const updateMessageRowNew = (row) => {
		setData((prevRows) => {
			const updatedRows = [row, ...prevRows];
			return updatedRows;
		});
	};

	const handleEdit = (rec) => {
		setShowEdit(true);
		setDataDetail(rec);
	};

	const closeEdit = () => {
		setShowEdit(false);
	};

	const updateMessageRowEdit = (row) => {
		setData((prevRows) => {
			const updatedRows = prevRows.map((item, idex) => {
				if (item.ID === row.ID) {
					item.NOTE = row.NOTE;
					item.NOTES = row.NOTES;
				}

				return item;
			});

			return updatedRows;
		});
	};

	const updateMessageRowDelete = (id) => {
		setData((prevRows) => {
			const updatedRows = prevRows.filter((item, idex) => {
				return item.ID !== id;
			});

			return updatedRows;
		});
	};

	const handleShowReaded = (id) => {
		setMessageId(id);
		setShowReaded(true);
	};

	const closeReaded = () => {
		setShowReaded(false);
	};

	const list = data.map((item, index) => (
		<div className="message-page__card message-page__card--sysadmin" key={item.ID || index}>
			<div className="message-page__card-head">
				<div className="message-page__card-meta message-page__card-meta--sysadmin">
					<div className="message-page__card-date">{item.CRDTS}</div>
					<div className="message-page__card-tools">
						<button
							type="button"
							className="message-page__meta-link"
							onClick={() => handleShowReaded(item.ID)}
						>
							{item.READ_CNT} četlo
						</button>
						<button
							type="button"
							className="message-page__icon-button"
							onClick={() => handleEdit(item)}
							aria-label="Upravit zprávu"
						>
							<img className="icon1 edit" alt="" />
						</button>
					</div>
				</div>
			</div>
			<div className="message-page__card-body txt_l">
				<span dangerouslySetInnerHTML={{__html: item.NOTES}} style={{wordWrap: 'break-word'}}></span>
			</div>
		</div>
	));

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showSearch searchValue={searchValue} onChangeSearch={(e) => onChangeSearch(e)} showNew handleNew={handleNew}></Search>
				<MessageSysadminReaded showReaded={showReaded} closeReaded={closeReaded} messageId={messageId} />
				<MessageSysadminNew showNew={showNew} closeNew={closeNew} updateMessageRowNew={updateMessageRowNew} />
				<MessageSysadminEdit showEdit={showEdit} closeEdit={closeEdit} updateMessageRowEdit={updateMessageRowEdit} data={dataDetail} updateMessageRowDelete={updateMessageRowDelete} />

				<div className={`page message-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<div className="message-page__list">
						{list.length > 0 ? list : <div className="message-page__empty">Žádné zprávy nebyly nalezeny.</div>}
					</div>

					<div className="message-page__load-more">
						{parseInt(loadedCnt) === parseInt(usrInfo.LIST_ROWS) ? (
							<button className="button small loadNext message-page__button" onClick={() => loadNext()}>
								Načíst další
							</button>
						) : (
							<span className="fnt_12 loadNext message-page__load-all">Byly načteny všechny záznamy</span>
						)}
					</div>
				</div>
			</div>
		</>
	);
}
